export const Choices = {
    A: 'A',
    B: 'B'
}

export const PageTypes = {
    INTRO: 'Inleiding',
    CHOICE: 'Keuze',
    REPONSE: 'Reponse'
}